// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"6459703f","453":"17f92e34"}[chunkId] + ".chunk.js";
};